let Roadmapdata = [
    {
      id: 1,
      title: "Phase 1",
        description1:
        "⦁ Marketing push on Twitter.",
        description2:
        "⦁ Collaboration with well-established projects.",
        description3:
        "⦁ Aquire NFTs and build the investors vault.",
        description4:
        "⦁ Aquire NFTs and build the MIRA community Vault.", 
        description5:
        "⦁ Whitelist through Twitter giveaways and Discord games.", 
        description6:
        "⦁ Building an organic community.",  
       
      date: "April 2022 - present",
      icon: "mark",
    },
    {
      id: 2,
      title: "Phase 2",
      description1:
        "⦁ MIRA Society launches.",
        description2:
        "⦁ Whitelist mint on July 7.",
        description3:
        "⦁ Public mint on July 8.",
        description4:
        "⦁ Whitelist benefits with early mint day and lower price.",
       
      date: "April 2022 - present",
      icon: "mark",
    },
    {
      id: 3,
      title: "Phase 3",
      description1:
      "⦁ Expand MIRA to reach all platforms and will keep growing to as many languages as we can.",
      description2:
      "⦁ Build a strong relationship with other communities.",
      description3:
      "⦁ MIRA collection sellout.",
      description4:
      "⦁ Provide MIRA school with teachers to teach different languages.",
      description5:
      "⦁ Allow holders of MIRA NFT to get alpha for upcoming projects.",
      
      date: "April 2022 - present",
      icon: "nomark",
    },
    {
      id: 4,
      title: "Phase 4",
      
        description1:
        "⦁ Start on three free mint collections. Second collection will be exclusively free to only MIRA holders as well as partnering projects. Third collection with only be free for MIRA holders. Fourth collection TBA.",
        description2:
        "⦁ Enter the Metaverse.",
        description3:
        "⦁ Keep providing utilities in MIRA.",
      date: "April 2022 - present",
      icon: "nomark",
    },
    // {
    //   id: 5,
    //   title: "Phase 5",
    //   description1:
    //     "•	Entering the Metaverse in a unique way, and that was discussed with the OG investors. More info will be shared later with holders.",
    //   date: "2022 - 2023",
    //   icon: "nomark",
    // },
    // {
    //   id: 6,
    //   title: "Phase 6",
    //   description1:
    //     "•	Continuous intense marketing during the whole journey and adding more utilities along the way.",
     
    //   date: "2023 - 2024",
    //   icon: "nomark",
    // },
  ];
  
  export default Roadmapdata;